// extracted by mini-css-extract-plugin
export default {"loading":"NaplanLanguageConventionsReview_loading__vecx6"};